import React, { useState, useRef, useEffect } from 'react';
import "../Styles/CreateUser.css";
import { useNavigate, useLocation } from 'react-router-dom';
import { ErrorMessage, Formik, Form, Field } from "formik";
import Axios from "axios";
import { toast, ToastContainer, toast as toastHelper } from 'react-toastify';
import UserProfileHeader from './UserProfileHeader'; 
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

const TestYubiKey = () => {
    const navigate = useNavigate();
    const [openYubikeyDialog, setOpenYubikeyDialog] = useState(false);
    const [yubikeyCode, setYubikeyCode] = useState('');
    const yubikeyInputRef = useRef(null);
    const dialogContentRef = useRef(null);
    const formResetRef = useRef(null);


    const initialValues = {
        yubikeyserialnumber: '',
    };

    const handleYubikeyVerification = () => {
        const serial = document.querySelector("input[name='yubikeyserialnumber']").value;

        Axios.post(`/test_yubikey`, {
            serial,
            otp: yubikeyCode.slice(0, 12),
        }).then((response) => {
            if (response.data.success) {
                toast.success(response.data.msg || "YubiKey verified successfully!");
                setOpenYubikeyDialog(false);
                if (formResetRef.current) {
                    formResetRef.current();
                }
            } else {
                toast.error(response.data.msg || "Verification failed.");
                if (yubikeyInputRef.current) {
                    yubikeyInputRef.current.focus();
                }
            }
            setYubikeyCode('');
        }).catch((error) => {
            toast.error("Server error during verification.");
            setYubikeyCode('');
            if (yubikeyInputRef.current) {
                yubikeyInputRef.current.focus();
            }
        });
    };

    return (
        <div className="dashboard">
            <UserProfileHeader isAdmin={true} />
            <div className='register-card'>
                <h1 className='register'>Test VELOX Cloud Key</h1>
                <Formik
                    initialValues={{ yubikeyserialnumber: '' }}
                    onSubmit={(values, { resetForm }) => {
                        formResetRef.current = resetForm;
                        setOpenYubikeyDialog(true);
                    }}
                >
                    <Form className="register-form">
                        <div className="register-form-group">
                            <Field name="yubikeyserialnumber" type='text' className="register-form-yubikeyserialnumber-field" placeholder="YubiKey Serial Number" />
                        </div>

                        <button className="createuser-button" type="submit">
                            Verify YubiKey
                        </button>
                    </Form>
                </Formik>
            </div>

            <Dialog open={openYubikeyDialog} onClose={() => setOpenYubikeyDialog(false)}>
                <DialogTitle>YubiKey Verification</DialogTitle>
                <DialogContent ref={dialogContentRef}>
                    <p>Please insert your YubiKey, touch it, and then verify.</p>
                    <input
                        type="text"
                        ref={yubikeyInputRef}
                        className="yubikeycode-field-hidden"
                        placeholder="Enter YubiKey Code"
                        value={yubikeyCode}
                        onChange={(e) => setYubikeyCode(e.target.value)}
                        autoFocus
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenYubikeyDialog(false)} color="secondary">Cancel</Button>
                    <Button onClick={handleYubikeyVerification} color="primary" disabled={!(yubikeyCode && yubikeyCode.length >= 12)}>
                        Verify
                    </Button>
                </DialogActions>
            </Dialog>
            <ToastContainer position='top-right' />
        </div>
    );
};

export default TestYubiKey;
